// Mock data for the INN Admin Dashboard

// Vendor Types
export const VENDOR_TYPES = [
  'Restaurant',
  'Cinema',
  'Sport',
  'Activity',
  'Café',
  'Entertainment',
  'Adventure',
]

// Vendor Status
export const VENDOR_STATUS = {
  SHOWN: 'Shown',
  HIDDEN: 'Hidden',
}

// Plan Categories
export const PLAN_CATEGORIES = [
  'Friends',
  'Date Night',
  'Family',
  'Adventure',
  'Sports',
  'Chill',
  'Luxury',
  'Kids',
  'Romantic',
  'Outdoor',
  'Food',
  'Padel',
]

// New Vendor Tag Categories
export const VENDOR_TAG_CATEGORIES = {
  priceRange: [
    'Under 200 EGP',
    '200 – 300 EGP',
    '300 – 500 EGP',
    '500 – 1000 EGP',
    'Premium',
  ],
  activityType: [
    'Food',
    'Cafe',
    'Padel',
    'Football',
    'Bowling',
    'Cinema',
    'Arcade',
    'Live Music',
    'Gaming',
    'Workshop',
    'Spa',
    'Outdoor Adventure',
  ],
  socialType: [
    'Individual',
    'Couple',
    'Group',
    'Family',
    'Kids Friendly',
    'Corporate',
  ],
  mood: [
    'Relaxed',
    'Romantic',
    'Energetic',
    'Competitive',
    'Luxury',
    'Casual',
    'Lively',
  ],
  timePreference: [
    'Morning',
    'Afternoon',
    'Evening',
    'Night',
  ],
  locationType: [
    'Indoor',
    'Outdoor',
    'Nile View',
    'Mall',
    'Compound',
    'Downtown',
  ],
  activityLevel: [
    'Light',
    'Moderate',
    'Intense',
  ],
}

// Mock Vendors Data
export const mockVendors = [
  {
    id: 1,
    name: 'The Gourmet Bistro',
    type: 'Restaurant',
    logo: 'https://ui-avatars.com/api/?name=Gourmet+Bistro&background=02c0a7&color=fff&size=100&bold=true',
    location: 'Downtown, Cairo',
    contact: '+20 100 123 4567',
    email: 'contact@gourmetbistro.com',
    rating: 4.8,
    totalBookings: 342,
    appearanceCount: 89,
    revenue: 125400,
    status: 'Shown',
    categories: ['Friends', 'Date Night', 'Luxury'],
    joinedDate: '2024-01-15',
    description: 'Fine dining experience with international cuisine',
    capacity: 80,
    priceRange: '500-1500',
  },
  {
    id: 2,
    name: 'CineMax Theater',
    type: 'Cinema',
    logo: 'https://ui-avatars.com/api/?name=CineMax&background=8b5cf6&color=fff&size=100&bold=true',
    location: 'Mall of Egypt, Giza',
    contact: '+20 100 234 5678',
    email: 'info@cinemax.com',
    rating: 4.6,
    totalBookings: 567,
    appearanceCount: 234,
    revenue: 89300,
    status: 'Shown',
    categories: ['Friends', 'Date Night', 'Family'],
    joinedDate: '2024-02-01',
    description: 'Modern cinema with IMAX and VIP screens',
    capacity: 300,
    priceRange: '100-300',
  },
  {
    id: 3,
    name: 'Padel Pro Club',
    type: 'Sport',
    logo: 'https://ui-avatars.com/api/?name=Padel+Pro&background=10b981&color=fff&size=100&bold=true',
    location: 'New Cairo',
    contact: '+20 100 345 6789',
    email: 'booking@padelproclub.com',
    rating: 4.9,
    totalBookings: 445,
    appearanceCount: 156,
    revenue: 234500,
    status: 'Shown',
    categories: ['Friends', 'Sports', 'Adventure', 'Date Night'],
    joinedDate: '2024-01-20',
    description: 'Premium padel courts with coaching available',
    capacity: 40,
    priceRange: '200-600',
  },
  {
    id: 4,
    name: 'Artisan Coffee House',
    type: 'Café',
    logo: 'https://ui-avatars.com/api/?name=Artisan+Cafe&background=f59e0b&color=fff&size=100&bold=true',
    location: 'Zamalek, Cairo',
    contact: '+20 100 456 7890',
    email: 'hello@artisancoffee.com',
    rating: 4.7,
    totalBookings: 678,
    appearanceCount: 298,
    revenue: 67800,
    status: 'Shown',
    categories: ['Friends', 'Chill', 'Date Night'],
    joinedDate: '2024-03-10',
    description: 'Cozy café with specialty coffee and pastries',
    capacity: 50,
    priceRange: '50-200',
  },
  {
    id: 5,
    name: 'Adventure Zone',
    type: 'Activity',
    logo: 'https://ui-avatars.com/api/?name=Adventure+Zone&background=ef4444&color=fff&size=100&bold=true',
    location: 'October City',
    contact: '+20 100 567 8901',
    email: 'info@adventurezone.com',
    rating: 4.5,
    totalBookings: 289,
    appearanceCount: 87,
    revenue: 145600,
    status: 'Shown',
    categories: ['Adventure', 'Friends', 'Kids'],
    joinedDate: '2024-05-15',
    description: 'Indoor climbing, zip-lining, and obstacle courses',
    capacity: 60,
    priceRange: '300-800',
  },
  {
    id: 6,
    name: 'Sunset Lounge',
    type: 'Restaurant',
    logo: 'https://ui-avatars.com/api/?name=Sunset+Lounge&background=ec4899&color=fff&size=100&bold=true',
    location: 'North Coast',
    contact: '+20 100 678 9012',
    email: 'reservations@sunsetlounge.com',
    rating: 4.9,
    totalBookings: 234,
    appearanceCount: 67,
    revenue: 189400,
    status: 'Shown',
    categories: ['Luxury', 'Date Night', 'Romantic'],
    joinedDate: '2024-02-28',
    description: 'Upscale dining with sea views',
    capacity: 100,
    priceRange: '800-2000',
  },
]

// Mock Plans (Hangouts) Data
export const mockPlans = [
  {
    id: 1,
    title: 'Perfect Date Night',
    category: 'Date Night',
    description: 'Romantic evening with dinner and movie',
    price: 850,
    duration: 240,
    capacity: 2,
    bookings: 45,
    status: 'Published',
    isPublic: true,
    createdDate: '2024-06-01',
    activities: [
      {
        id: 1,
        vendorId: 1,
        vendorName: 'The Gourmet Bistro',
        type: 'Restaurant',
        duration: 120,
        price: 500,
        time: '19:00',
        order: 1,
      },
      {
        id: 2,
        vendorId: 2,
        vendorName: 'CineMax Theater',
        type: 'Cinema',
        duration: 120,
        price: 350,
        time: '21:30',
        order: 2,
      },
    ],
    slots: [
      { date: '2024-06-20', time: '19:00', available: 2, booked: 0 },
      { date: '2024-06-21', time: '19:00', available: 2, booked: 1 },
      { date: '2024-06-22', time: '19:00', available: 2, booked: 2 },
    ],
  },
  {
    id: 2,
    title: 'Friends Sports Day',
    category: 'Sports',
    description: 'Active day with padel and lunch',
    price: 1200,
    duration: 300,
    capacity: 4,
    bookings: 67,
    status: 'Published',
    isPublic: true,
    createdDate: '2024-06-05',
    activities: [
      {
        id: 1,
        vendorId: 3,
        vendorName: 'Padel Pro Club',
        type: 'Sport',
        duration: 120,
        price: 600,
        time: '10:00',
        order: 1,
      },
      {
        id: 2,
        vendorId: 4,
        vendorName: 'Artisan Coffee House',
        type: 'Café',
        duration: 60,
        price: 200,
        time: '12:30',
        order: 2,
      },
      {
        id: 3,
        vendorId: 1,
        vendorName: 'The Gourmet Bistro',
        type: 'Restaurant',
        duration: 120,
        price: 400,
        time: '14:00',
        order: 3,
      },
    ],
    slots: [
      { date: '2024-06-20', time: '10:00', available: 4, booked: 2 },
      { date: '2024-06-21', time: '10:00', available: 4, booked: 4 },
    ],
  },
  {
    id: 3,
    title: 'Luxury Evening Experience',
    category: 'Luxury',
    description: 'Premium dining at sunset lounge',
    price: 1800,
    duration: 180,
    capacity: 2,
    bookings: 23,
    status: 'Published',
    isPublic: false,
    createdDate: '2024-06-10',
    activities: [
      {
        id: 1,
        vendorId: 6,
        vendorName: 'Sunset Lounge',
        type: 'Restaurant',
        duration: 180,
        price: 1800,
        time: '20:00',
        order: 1,
      },
    ],
    slots: [{ date: '2024-06-20', time: '20:00', available: 2, booked: 0 }],
  },
  {
    id: 4,
    title: 'Family Adventure Day',
    category: 'Family',
    description: 'Fun activities for the whole family',
    price: 2400,
    duration: 360,
    capacity: 6,
    bookings: 34,
    status: 'Draft',
    isPublic: true,
    createdDate: '2024-06-12',
    activities: [
      {
        id: 1,
        vendorId: 5,
        vendorName: 'Adventure Zone',
        type: 'Activity',
        duration: 180,
        price: 1200,
        time: '10:00',
        order: 1,
      },
      {
        id: 2,
        vendorId: 1,
        vendorName: 'The Gourmet Bistro',
        type: 'Restaurant',
        duration: 90,
        price: 800,
        time: '13:30',
        order: 2,
      },
      {
        id: 3,
        vendorId: 2,
        vendorName: 'CineMax Theater',
        type: 'Cinema',
        duration: 90,
        price: 400,
        time: '15:30',
        order: 3,
      },
    ],
    slots: [],
  },
]

// Mock Categories with Rules
export const mockCategories = [
  {
    id: 1,
    name: 'Date Night',
    description: 'Romantic experiences for couples',
    icon: 'Heart',
    status: 'Active',
    plansCount: 12,
  },
  {
    id: 2,
    name: 'Sports',
    description: 'Active and energetic activities',
    icon: 'Activity',
    status: 'Active',
    plansCount: 8,
  },
  {
    id: 3,
    name: 'Family',
    description: 'Fun for all ages',
    icon: 'Users',
    status: 'Active',
    plansCount: 15,
  },
  {
    id: 4,
    name: 'Luxury',
    description: 'Premium high-end experiences',
    icon: 'Gem',
    status: 'Active',
    plansCount: 6,
  },
  {
    id: 5,
    name: 'Friends',
    description: 'Casual hangouts with friends',
    icon: 'Coffee',
    status: 'Active',
    plansCount: 24,
  },
  {
    id: 6,
    name: 'Food',
    description: 'Delicious dining and culinary experiences',
    icon: 'Utensils',
    status: 'Active',
    plansCount: 30,
  },
  {
    id: 7,
    name: 'Padel',
    description: 'Padel matches and tournaments',
    icon: 'Trophy',
    status: 'Active',
    plansCount: 24,
  },
]

// Mock Users Data
export const mockUsers = [
  {
    id: 1,
    name: 'Ahmed Hassan',
    email: 'ahmed.hassan@example.com',
    phone: '+20 100 111 2222',
    joinDate: '2024-01-15',
    hangoutsJoined: 12,
    totalSpent: 8500,
    status: 'Active',
    friends: 45,
    reviews: 8,
    lastActivity: '2024-06-15',
    fraudFlags: 0,
  },
  {
    id: 2,
    name: 'Sara Mohamed',
    email: 'sara.mohamed@example.com',
    phone: '+20 100 222 3333',
    joinDate: '2024-02-20',
    hangoutsJoined: 23,
    totalSpent: 15600,
    status: 'Active',
    friends: 67,
    reviews: 15,
    lastActivity: '2024-06-18',
    fraudFlags: 0,
  },
  {
    id: 3,
    name: 'Omar Ali',
    email: 'omar.ali@example.com',
    phone: '+20 100 333 4444',
    joinDate: '2024-03-10',
    hangoutsJoined: 8,
    totalSpent: 4200,
    status: 'Active',
    friends: 23,
    reviews: 5,
    lastActivity: '2024-06-10',
    fraudFlags: 0,
  },
  {
    id: 4,
    name: 'Layla Ibrahim',
    email: 'layla.ibrahim@example.com',
    phone: '+20 100 444 5555',
    joinDate: '2024-04-05',
    hangoutsJoined: 34,
    totalSpent: 23400,
    status: 'Active',
    friends: 89,
    reviews: 22,
    lastActivity: '2024-06-19',
    fraudFlags: 0,
  },
  {
    id: 5,
    name: 'Karim Farouk',
    email: 'karim.farouk@example.com',
    phone: '+20 100 555 6666',
    joinDate: '2024-05-01',
    hangoutsJoined: 3,
    totalSpent: 1800,
    status: 'Suspended',
    friends: 12,
    reviews: 1,
    lastActivity: '2024-06-01',
    fraudFlags: 2,
  },
]

// Mock Moderation Data
export const mockReports = [
  {
    id: 1,
    type: 'User',
    reportedItem: 'Karim Farouk',
    reportedBy: 'Sara Mohamed',
    reason: 'Inappropriate behavior during hangout',
    description: 'User was rude to other participants and disrupted the event',
    date: '2024-06-15',
    status: 'Pending',
    severity: 'High',
  },
  {
    id: 2,
    type: 'Plan',
    reportedItem: 'Beach Party Night',
    reportedBy: 'Ahmed Hassan',
    reason: 'Misleading information',
    description: 'Plan description did not match actual activities provided',
    date: '2024-06-14',
    status: 'Under Review',
    severity: 'Medium',
  },
  {
    id: 3,
    type: 'Vendor',
    reportedItem: 'Adventure Zone',
    reportedBy: 'Layla Ibrahim',
    reason: 'Safety concerns',
    description: 'Equipment not properly maintained, potential safety hazard',
    date: '2024-06-13',
    status: 'Resolved',
    severity: 'High',
  },
  {
    id: 4,
    type: 'Review',
    reportedItem: 'Fake positive review',
    reportedBy: 'Omar Ali',
    reason: 'Spam/Fake review',
    description: 'Suspicious review pattern detected',
    date: '2024-06-12',
    status: 'Pending',
    severity: 'Low',
  },
]

// Mock Analytics Data
export const mockAnalytics = {
  kpis: {
    activeUsers: 2543,
    activeUsersChange: 12.5,
    dailyBookings: 45,
    dailyBookingsChange: 8.2,
    revenue: 125400,
    revenueChange: 15.3,
    cancellationRate: 2.3,
    cancellationRateChange: -0.5,
  },
  bookingsOverTime: [
    { date: '2024-06-01', bookings: 32 },
    { date: '2024-06-02', bookings: 28 },
    { date: '2024-06-03', bookings: 45 },
    { date: '2024-06-04', bookings: 38 },
    { date: '2024-06-05', bookings: 52 },
    { date: '2024-06-06', bookings: 48 },
    { date: '2024-06-07', bookings: 55 },
  ],
  categoryDistribution: [
    { name: 'Friends', value: 35 },
    { name: 'Date Night', value: 25 },
    { name: 'Family', value: 20 },
    { name: 'Sports', value: 12 },
    { name: 'Luxury', value: 8 },
  ],
  topVendors: [
    { name: 'The Gourmet Bistro', appearances: 89, revenue: 125400 },
    { name: 'CineMax Theater', appearances: 234, revenue: 89300 },
    { name: 'Padel Pro Club', appearances: 156, revenue: 234500 },
    { name: 'Artisan Coffee House', appearances: 298, revenue: 67800 },
    { name: 'Sunset Lounge', appearances: 67, revenue: 189400 },
  ],
  peakHours: [
    { hour: '10:00', bookings: 15 },
    { hour: '12:00', bookings: 25 },
    { hour: '14:00', bookings: 32 },
    { hour: '16:00', bookings: 28 },
    { hour: '18:00', bookings: 45 },
    { hour: '20:00', bookings: 52 },
    { hour: '22:00', bookings: 18 },
  ],
}

// System Settings
export const mockSettings = {
  commission: 15,
  currency: 'EGP',
  minBookingAdvance: 24,
  maxBookingAdvance: 90,
  cancellationWindow: 48,
  autoApproveVendors: false,
  maintenanceMode: false,
  featureFlags: {
    aiRecommendations: true,
    chatSupport: true,
    reviewSystem: true,
    loyaltyProgram: false,
  },
}

// Admin Roles
export const ADMIN_ROLES = [
  { id: 1, name: 'Super Admin', permissions: 'all' },
  { id: 2, name: 'Operations', permissions: 'vendors,plans,bookings' },
  { id: 3, name: 'Vendor Manager', permissions: 'vendors,categories' },
  { id: 4, name: 'Support Agent', permissions: 'users,moderation' },
  { id: 5, name: 'Analyst', permissions: 'analytics,read-only' },
]

// Plan Questionnaire Data
export const mockQuestionnaire = [
  {
    id: 1,
    text: 'Location',
    type: 'single',
    required: true,
    choices: ['Tagamo3', 'Zayed'],
  },
  {
    id: 2,
    text: 'Budget',
    type: 'single',
    required: true,
    choices: ['Low Budget', 'Medium Budget', 'High Budget'],
  },
  {
    id: 3,
    text: 'Capacity (People Count)',
    type: 'single',
    required: true,
    choices: ['1–2 People', '3–5 People', '6–10 People', '10+ People'],
  },
  {
    id: 4,
    text: 'Activities',
    type: 'multi',
    required: true,
    choices: ['Eat', 'Sports', 'Cafe'],
  },
]
